import './App.css';
import HomePage from "./components/HomePage";
import Footer from "./components/Footer";
import Presentation from "./components/Presentation";
import Programme from "./components/Programme";
import Debouche from "./components/Debouche";
import Contact from "./components/Contact";

function App() {
  return (
    <>
      <HomePage />
      <Presentation />
      <Programme />
      <Debouche />
      <Contact />
      <Footer />
    </>
  );
}

export default App;
